// URL safety helpers.
//
// Poster-supplied URLs (post external_url, project repo_url) are rendered into
// anchor hrefs. React does NOT block `javascript:` / `data:` URLs in href, so a
// stored URL with such a scheme would execute as XSS when clicked. The backend
// validates the scheme on write, but we guard again at render time as
// defense-in-depth (and to cover any data stored before validation existed).

/**
 * True only for http/https URLs — the only schemes safe to place in an href.
 * Typed as a predicate so a truthy check narrows `string | null` to `string`
 * at the call site (lets the URL be used directly in an href).
 */
export function isSafeHttpUrl(url: string | null | undefined): url is string {
  if (!url) return false;
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}
